module.exports = __webpack_public_path__ + "img/Apple-store.2fce16b9.svg";